export default "__VITE_ASSET__DkROKK6N__"